<template>
  <div class="container" v-if="isShowWebSite">
    <banner
      v-if="showBanner"
      :type="type"
      :listInfo="listInfo"
      :currentTag="currentTag"
    ></banner>
    <!-- <intelligent-wearable id="intelligent-wearable"></intelligent-wearable>
    <product-box id="product-box"></product-box> -->
    <announce-box id="announce-box"></announce-box>
    <news-box id="news-box"></news-box>
    <about-us id="about-us"></about-us>
    <!-- <join-us id="join-us"></join-us> -->
    <moni-footer></moni-footer>
    <div>
      <msg-box></msg-box>
      <top-arrow></top-arrow>
    </div>
    <!--<div>
      <video-box ref="videoHook"></video-box>
    </div>-->
  </div>
  <div v-else class="container-other">
    <img src="../../assets/images/developing.png"/>
  </div>
</template>

<script>
import banner from "../../components/banner/banner";
import intelligentWearable from "./components/intelligentWearable"
import announceBox from "./components/announceBox";
import newsBox from "./components/newsBox";
import productBox from "./components/productBox";
import aboutUs from "./components/aboutUs";
import joinUs from "./components/joinUs";
import moniFooter from "../../components/moniFooter/moniFooter";
import msgBox from "../../components/msgBox/msgBox";
import topArrow from "../../components/topArrow/topArrow";
import videoBox from "../../components/videoBox/videoBox";
import http from "../../api/http.js";
import apiUrl from "../../api/apiUrl.js";
import "jquery";

export default {
  name: "Index",
  data() {
    return {
      type: "swiper",
      listInfo: [],
      isShowVideo: false,
      currentTag: 0,
      showBanner: false,
      isShowWebSite: true
    };
  },
  mounted() {},
  watch: {},
  computed: {},
  created() {
    console.log(window.Glod)
    console.log(window.Glod.isShowWebSite)
    if (!window.Glod.isShowWebSite) {
      this.isShowWebSite = window.Glod.isShowWebSite
    }
    this.fetchBanner();
  },
  methods: {
    // 获取轮播数据
    fetchBanner() {
      http.get(apiUrl.banner).then(response => {
        if (response.code == 0) {
          // 不必要
          let data = response.data;
          this.listInfo = data;
          this.showBanner = true;
        }
      });
    }
  },
  components: {
    banner,
    newsBox,
    productBox,
    aboutUs,
    joinUs,
    moniFooter,
    msgBox,
    topArrow,
    videoBox,
    announceBox,
    intelligentWearable
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}
.container-other{
  width: 100%;
  height: 100vh;
  background-color:#F5F6F6;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    width:657px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue